import React, { Component } from 'react';
import MainStore from '../../../MainStore'
import PeopleStatisticSchedulleRow from './PeopleStatisticSchedulleRow'
import PeriodPicker from './PeriodPicker'
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

export default class PeopleStatisticSchedulle extends Component {

    constructor(props) {
        super(props);
        this.state = {
            peoples: [],
            viewType: -1
        };

        this.handleViewTypeChange = this.handleViewTypeChange.bind(this);
        this.load = this.load.bind(this);
        this.handlePeriodChange = this.handlePeriodChange.bind(this);
    }

    componentDidMount() {
        this.load();
    }

    load(viewType, dates) {
        var scope = this;
        MainStore.setMaskVisible();
        fetch('api/Schedulle/People?viewType=' + (viewType === undefined ? this.state.viewType : viewType) + '&start=' + (dates ? dates.start.toISOString() : ''), {
            method: 'GET',
            body: null,
        }).then(function (res) {
            if (res.status === 401) {
                MainStore.setMaskUnvisible();
            }
            else {
                res.json().then((result) => {
                    scope.setState({ peoples: result });
                    MainStore.setMaskUnvisible();
                }).catch((err) => console.log(err));
            }
        });
    }

    handleViewTypeChange = name => evt => {
        this.setState({ [name]: evt.target.value });
        this.load(evt.target.value);
    }

    handlePeriodChange(dates) {
        this.setState({ dates: dates });
        this.load(this.state.viewType, dates);
    }

    render() {
        var maxMinutes = 0;
        if (this.state.peoples) {
            maxMinutes = Math.max.apply(null, this.state.peoples.map(p => p.factMinutes))
        }
        return (
            <div className="people-schedulle-block">
                <Select
                    value={this.state.viewType}
                    onChange={this.handleViewTypeChange('viewType')}
                >
                    <MenuItem value={-1}>День</MenuItem>
                    <MenuItem value={0}>Неделя</MenuItem>
                    <MenuItem value={1}>Месяц</MenuItem>
                    <MenuItem value={2}>Год</MenuItem>
                    <MenuItem value={3}>Все время</MenuItem>
                </Select>
                <PeriodPicker viewType={this.state.viewType} onPeriodChange={this.handlePeriodChange} />
                {this.state.peoples.map(p => <div><PeopleStatisticSchedulleRow maxMinutes={maxMinutes} value={p} dates={this.state.dates} viewType={this.state.viewType} /><br /></div>)}
            </div>);
    }
}